import React from "react";
import { Box } from "@mui/material";
import OrderCard from "./orderCards";
import LowInStockCards from "./lowInStockCards";
import InventoryActionTable from "./InventoryActionTable";
import FavouriteItem from "./favouriteItem";
import StyledDashboard from "./StyledDashboard";
import { useDashboard } from "../../hooks/common-hooks/useDashboard";

const PrivateDashboard = () => {
  const { lowInStockProducts, lowInStockProductsLoading, favDataLoading, favData, dashboardData, dashboardDataLoading } = useDashboard()
  return (
    <div className="mobile-dashboard-container">
      <OrderCard dashboardData={dashboardData} loading={dashboardDataLoading} />

      <StyledDashboard>
        <Box className="main-box">
          <LowInStockCards loading={lowInStockProductsLoading} products={lowInStockProducts} />
          <FavouriteItem favDataLoading={favDataLoading} favData={favData} />
        </Box>
      </StyledDashboard>


      <InventoryActionTable />
    </div>
  );
};

export default PrivateDashboard;
